import type { MediaQueryAllQueryable, MediaQueryMatchers } from 'react-responsive';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINTS } from '@constants/layout.ts';

export interface ResponsiveReturnValues {
    isLaptop: boolean;
    isBigScreen: boolean;
    useMediaQuery: (
        settings: Partial<MediaQueryAllQueryable & { query?: string | undefined }>,
        device?: MediaQueryMatchers,
        callback?: (matches: boolean) => void,
    ) => boolean;
}

export const useResponsive = (): ResponsiveReturnValues => {
    const laptopOnly = useMediaQuery({
        query: `(min-width: ${BREAKPOINTS.laptop}px) and (max-width: ${BREAKPOINTS.desktopFullHD - 0.02}px)`,
    });

    const bigScreenOnly = useMediaQuery({
        query: `(min-width: ${BREAKPOINTS.desktopFullHD}px)`,
    });

    return {
        isLaptop: laptopOnly,
        isBigScreen: bigScreenOnly,
        useMediaQuery,
    };
};
